/**
 * AdminToolsCard - Outils d'administration
 * Extrait de Profile.js pour améliorer la maintenabilité
 * AMIRAUX UNIQUEMENT
 */
import React from 'react';
import { Settings, Sparkles, Wifi, Database, MessageSquare } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';

export const AdminToolsCard = ({ navigate }) => (
  <Card className="relative bg-gradient-to-br from-amber-950/30 to-slate-900/50 backdrop-blur-xl border-amber-800/40">
    <CardHeader>
      <CardTitle className="text-xl md:text-2xl font-orbitron uppercase tracking-wider text-amber-400 flex items-center">
        <Settings className="w-5 h-5 md:w-6 md:h-6 mr-2 md:mr-3" />
        Outils d&apos;administration
      </CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-sm text-slate-400 mb-4">
        Accès réservé aux Amiraux pour la configuration avancée de l&apos;application.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        <Button
          onClick={() => navigate('/admin/prompts')}
          className="bg-amber-500/20 hover:bg-amber-500/30 text-amber-300 border border-amber-500/50 hover:border-amber-400 justify-start"
          data-testid="btn-admin-prompts"
        >
          <Sparkles className="w-4 h-4 mr-2" />
          Gestion des Prompts
        </Button>
        <Button
          onClick={() => navigate('/admin/api-connections')}
          className="bg-purple-500/20 hover:bg-purple-500/30 text-purple-300 border border-purple-500/50 hover:border-purple-400 justify-start"
          data-testid="btn-admin-api"
        >
          <Wifi className="w-4 h-4 mr-2" />
          Connexions API
        </Button>
        <Button
          onClick={() => navigate('/admin/llm-artifacts')}
          className="bg-cyan-500/20 hover:bg-cyan-500/30 text-cyan-300 border border-cyan-500/50 hover:border-cyan-400 justify-start"
          data-testid="btn-admin-artifacts"
        >
          <Database className="w-4 h-4 mr-2" />
          Artefacts LLM
        </Button>
        <Button
          onClick={() => navigate('/admin/interview-tracking')}
          className="bg-violet-500/20 hover:bg-violet-500/30 text-violet-300 border border-violet-500/50 hover:border-violet-400 justify-start"
          data-testid="btn-admin-interviews"
        >
          <MessageSquare className="w-4 h-4 mr-2" />
          Suivi Interviews
        </Button>
      </div>
    </CardContent>
  </Card>
);

export default AdminToolsCard;
